import React from "react";
import { useNavigate } from "react-router-dom";
import "./ProductCard.scss";

const ProductCard = ({ product, onAddToCart }) => {
  const navigate = useNavigate();

  const handleView = () => {
    if (!product.category) {
      alert("Category not available");
      return;
    }

    // Convert category to slug (ex: Bridal Set → bridal-set)
    const categorySlug = product.category.toLowerCase().replace(/\s+/g, "-");

    // Correct route → matches Collections.jsx (useParams → categoryId)
    navigate(`/collection/${categorySlug}`);
  };

  return (
    <div
      className="product-card"
      onClick={() => navigate(`/category/${product.id}`)}
      style={{ cursor: "pointer" }}
    >
      {" "}
      <div className="product-image-container">
        <img
          src={product.image}
          alt={product.name}
          className="product-image"
          loading="lazy"
        />

        <div className="product-overlay">
          <button className="btn btn-outline" onClick={handleView}>
            View
          </button>
        </div>
      </div>
      <div className="product-content">
        <h3 className="product-title">{product.name}</h3>
      </div>
    </div>
  );
};

export default ProductCard;
